
import roles from '@/core/roles';
import storage from '@/utils/storage';

const state = {
  data: {
    items: [
      {icon: 'home', text: 'home', link: '/'},
      {icon: 'schedule', text: 'timeline', link: 'timeline'},

      {icon: 'bar_chart', text: 'results', link: 'results'},
      {icon: 'person_pin', text: 'myDrivers', link: 'myDrivers'},
      {
        icon: 'how_to_reg',
        'icon-alt': 'keyboard_arrow_down',
        text: 'booqit',
        model: false,
        children: [
          {icon: 'assignment', text: 'planningBooqit', link: 'planningBooqit'},
          // {icon: 'timeline', text: 'distance', link: 'distance'},
          {icon: 'drive_eta', text: 'transportsBooqit', link: 'transportsBooqit'},
          {icon: 'euro_symbol', text: 'invoicesBooqit', link: 'invoicesBooqit'}
        ]
      },
      {
        icon: 'headset_mic',
        'icon-alt': 'keyboard_arrow_down',
        text: 'dispatching',
        model: true,
        children: [
          {icon: 'assignment', text: 'bookings', link: 'booking', line: true},
          {icon: 'person', text: 'clients', link: 'client'},
          {icon: 'drive_eta', text: 'drivers', link: 'driver'},
          {icon: 'domain', text: 'destinations', link: 'destination', line: true},
          {icon: 'hotel', text: 'careCenters', link: 'carecenter'},
          {icon: 'local_hospital', text: 'insurances', link: 'insurances'},
          {icon: 'local_hospital', text: 'mcodes', link: 'mcode'}
        ]
      },

      {
        icon: 'money',
        'icon-alt': 'keyboard_arrow_down',
        text: 'invoicing',
        model: false,
        children: [
          {icon: 'euro_symbol', text: 'driversWallets', link: 'walletdriver'},
          {icon: 'account_balance', text: 'driversInvoices', link: 'invoicesDrivers'},
          {icon: 'archive', text: 'driversArchive', link: 'archiveDrivers', line: true},
          {icon: 'euro_symbol', text: 'clientsWallets', link: 'walletclient'},
          {icon: 'account_balance', text: 'clientsInvoices', link: 'invoice'},
          {icon: 'archive', text: 'clientsArchive', link: 'archive', line: true},
          {icon: 'euro_symbol', text: 'insurancesWallets', link: 'walletinsurrance'},
          {icon: 'account_balance', text: 'insurancesInvoices', link: 'invoiceInsurance'},
          {icon: 'archive', text: 'insurancesArchive', link: 'archiveInsurances', line: true},
          {icon: 'add_box', text: 'inserts', link: 'inserts'},
          {icon: 'indeterminate_check_box', text: 'expenses', link: 'expenses'},
          {icon: 'receipt', text: 'tickets', link: 'tickets'}
        ]
      },
      // {icon: 'contact_mail', text: 'Campaign', link: 'campaign'},
      {
        icon: 'widgets',
        'icon-alt': 'keyboard_arrow_down',
        text: 'others',
        model: false,
        children: [
          // {icon: 'group', text: 'timeSheet', link: 'timesheet'},
          {icon: 'group', text: 'allUsers', link: 'users'},
          {icon: 'help', text: 'help', link: 'help'}
        ]
      }
    ]
  },
  menu: []
}

const actions = {
  setMenu ({commit}, data) {
    commit('save_menuData', data)
  },
  removeMenu ({commit}) {
    commit('set_menuData', [])
  }
}

const mutations = {
  save_menuData (state, u) {
    state.menu = state.data.items.filter(function f (o) {
      // console.log(roles.can(u.role, o.link), u.role, o.link);
      return roles.can(u.role, o.link) || (o.children && (o.children = o.children.filter(f)).length)
    })
    storage.save('menu', state.menu);
  },
  set_menuData (state, data) {
    state.menu = data
    storage.save('menu', data);
  }
}

const getters = {
  menuData: (state) => {
    return state.menu.length ? state.menu : storage.load('menu');
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}
